export default __webpack_public_path__ + "static/media/icon-insights-performance-catering.c7096fb0.svg";